import { render } from "./WidgetNatalChart.vue?vue&type=template&id=433c2b8c&scoped=true"
import script from "./WidgetNatalChart.vue?vue&type=script&lang=js"
export * from "./WidgetNatalChart.vue?vue&type=script&lang=js"

import "./WidgetNatalChart.vue?vue&type=style&index=0&id=433c2b8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-433c2b8c"]])

export default __exports__